const _excluded = ["icon", "size", "variant", "shape", "type", "selected", "disabled", "loading", "labelType", "onClick", "overrideClassName", "width"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { SpinnerIcon } from "../SpinnerIcon";
import { cx } from "../../helpers/utils/cx";
import { Tooltip } from "../Tooltip";
const NOOP = () => {};

// This naming could really be a lot better. Needs research.

const sizes = {
  sm: "w-9 h-9",
  md: "w-12 h-12",
  lg: "w-14 h-14"
};
const variants = {
  primary: "bg-action-primary hover:bg-active-action-primary text-static-key-light",
  ghost: "bg-transparent hover:bg-active-neutral-secondary text-primary",
  secondary: "bg-neutral-secondary hover:bg-active-neutral-secondary text-primary",
  filled: "bg-neutral-secondary hover:bg-active-neutral-secondary text-primary",
  danger: "bg-danger-primary hover:bg-active-danger-primary text-static-key-light",
  floating: "bg-layer-floor-2 shadow-md hover:shadow active:shadow text-primary",
  inverted: "bg-neutral-primary hover:bg-active-neutral-primary text-primary-inverted",
  "floating-inverted": "bg-neutral-primary shadow-md hover:bg-active-neutral-primary text-primary-inverted"
};
const shapes = {
  round: "rounded-full",
  square: "rounded-md"
};
const states = {
  disabled: {
    primary: "bg-neutral-secondary hover:bg-neutral-secondary active:bg-neutral-secondary cursor-not-allowed text-tertiary",
    secondary: "bg-transparent hover:bg-transparent active:bg-transparent cursor-not-allowed text-tertiary",
    floating: "cursor-not-allowed text-tertiary shadow-md"
  },
  loading: "bg-active-neutral-secondary text-primary cursor-progress",
  selected: "bg-neutral-primary text-primary-inverted"
};
const labelStyles = {
  sm: "bolt-font-body-xs-regular w-9",
  md: "bolt-font-body-xs-regular w-12",
  lg: "bolt-font-body-s-regular w-14"
};

/**
 * Decides which classlist to apply. Allows defining order of priority between various states.
 * @returns string of Tailwind classes
 */
function selectClasses(variant, disabled, selected, loading) {
  if (disabled) {
    if (["secondary", "ghost", "filled"].includes(variant)) {
      return states.disabled.secondary;
    }
    if (["floating", "floating-inverted"].includes(variant)) {
      return states.disabled.floating;
    }
    return states.disabled.primary;
  }
  if (loading) {
    return states.loading;
  }
  if (selected) {
    return states.selected;
  }
  return variants[variant];
}

/**
 * Always set the size prop to the same value as the Button size.
 * @returns IconElement with given size prop.
 */
function withSize(icon, size) {
  return /*#__PURE__*/React.cloneElement(icon, {
    size
  });
}
function IconButton(_ref, ref) {
  let {
      icon,
      size = "md",
      variant = "secondary",
      shape = "round",
      type = "button",
      selected = false,
      disabled = false,
      loading = false,
      labelType = "hidden",
      onClick,
      overrideClassName,
      width
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  // it does not make sense to be disabled and loading at the same time.
  const isLoading = !disabled && loading;
  const buttonContent = withSize(icon, size);
  const content = isLoading ? withSize( /*#__PURE__*/React.createElement(SpinnerIcon, {
    className: cx("animate-spin")
  }), size) : buttonContent;
  const iconButton = /*#__PURE__*/React.createElement("button", _extends({
    type: type // eslint-disable-line react/button-has-type -- rule would not allow consumers to set type and have a default
    ,
    disabled: disabled,
    onClick: isLoading ? NOOP : onClick,
    className: cx("inline-flex flex-col justify-center items-center", "border-none p-0 bg-special-nulled cursor-pointer", shape === "round" && labelType !== "text" ? "rounded-full" : "rounded-md", overrideClassName)
  }, props, {
    ref: ref,
    style: width ? _objectSpread(_objectSpread({}, props.style || {}), {}, {
      width
    }) : props.style
  }), /*#__PURE__*/React.createElement("span", {
    className: cx("flex justify-center items-center", "ease-linear duration-150", !disabled && "active:scale-975 active:ease-in-out active:duration-100", sizes[size], shapes[shape], selectClasses(variant, disabled, selected, loading), overrideClassName)
  }, content), labelType === "text" && /*#__PURE__*/React.createElement("span", {
    className: cx("inline-block antialiased truncate text-primary pt-1", labelStyles[size], width && "!w-full")
  }, props["aria-label"]));
  if (labelType === "tooltip") {
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: props["aria-label"]
    }, iconButton);
  }
  return iconButton;
}
const ForwardedIconButton = /*#__PURE__*/React.forwardRef(IconButton);
export { ForwardedIconButton as IconButton };